module.exports = __webpack_public_path__ + "img/aanbod.ccc28316.svg";